{
  "account": {
    "title": "Compte",
    "subtitle": "Votre nom est celui que Nolë utilise pour s'adresser à vous — il est transmis à l'assistant à chaque conversation. Le reste vient du service avec lequel vous vous êtes connecté.",
    "notSignedIn": "Vous n'êtes pas connecté.",
    "userId": "ID utilisateur",
    "name": {
      "placeholder": "Comment Nolë doit vous appeler",
      "providerHint": "Laissez vide pour garder « {{providerName}} », le nom fourni par votre service de connexion.",
      "updated": "Nom mis à jour",
      "cleared": "Nom effacé",
      "updateFailed": "Impossible de mettre à jour votre nom"
    },
    "theme": {
      "label": "Thème",
      "light": "Clair",
      "dark": "Sombre",
      "system": "Système"
    },
    "language": {
      "updateFailed": "Impossible d'enregistrer votre langue"
    },
    "signOut": {
      "action": "Se déconnecter",
      "confirmTitle": "Se déconnecter ?",
      "confirmText": "Vous devrez vous reconnecter pour retrouver vos canvas."
    },
    "danger": {
      "title": "Zone de danger",
      "description": "Supprimer votre compte efface vos canvas, vos conversations et tout ce dont Nolë se souvient. C'est irréversible."
    },
    "delete": {
      "action": "Supprimer mon compte",
      "title": "Supprimer votre compte",
      "description": "C'est irréversible. Supprimer votre compte efface définitivement :",
      "items": {
        "canvases": "vos canvas, avec tous les nodes, fichiers et connexions qu'ils contiennent",
        "conversations": "vos conversations avec Nolë, et tout ce qu'elle sait de vous",
        "skills": "vos skills, custom nodes et tokens d'API",
        "sharedAccess": "votre accès aux canvas que d'autres ont partagés avec vous"
      },
      "exportHint": "Vous voulez garder une copie ? <exportLink>Exportez vos données</exportLink> d'abord — ensuite, rien ne pourra être récupéré.",
      "confirmLabel": "Tapez <email>{{email}}</email> pour confirmer",
      "done": "Votre compte a été supprimé",
      "failed": "Impossible de supprimer votre compte"
    }
  },
  "groups": {
    "account": "Compte",
    "customization": "Personnalisation",
    "access": "Accès"
  },
  "sections": {
    "account": "Compte",
    "aiUsage": "Usage de l'IA",
    "export": "Exporter mes données",
    "templates": "Custom nodes",
    "skills": "Skills",
    "canvas": "Canvas",
    "memories": "Souvenirs de l'agent",
    "apiTokens": "MCP et tokens d'API",
    "sandbox": "L'ordinateur de Nolë"
  },
  "shell": {
    "close": "Fermer les réglages",
    "openMenu": "Ouvrir le menu des réglages",
    "pageError": "Impossible d'afficher cette page."
  },
  "export": {
    "title": "Exporter mes données",
    "subtitle": "Téléchargez vos canvas dans une archive ZIP : un fichier Markdown lisible par node, accompagné du JSON brut pour que rien ne se perde. Les images, PDF et fichiers audio ne sont pas inclus — l'archive y renvoie par leur URL.",
    "progress": {
      "listing": "Liste des canvas ({{total}})…",
      "zipping": "Création de l'archive…",
      "fetching": "Canvas {{current}} / {{total}}",
      "fetchingNamed": "Canvas {{current}} / {{total}} — {{name}}"
    },
    "done_one": "Export terminé ({{count}} canvas)",
    "done_other": "Export terminé ({{count}} canvas)",
    "failed": "L'export a échoué",
    "loading": "Chargement de vos canvas…",
    "empty": "Vous n'avez encore aucun canvas à exporter",
    "scope": {
      "all": "Tout",
      "allDescription_one": "Le canvas que vous avez créé ({{count}}), avec tous ses nodes.",
      "allDescription_other": "Les {{count}} canvas que vous avez créés, avec tous leurs nodes.",
      "allDescriptionMore_one": "Le canvas que vous avez créé ({{count}}) et d'autres, avec tous leurs nodes.",
      "allDescriptionMore_other": "Les {{count}} canvas que vous avez créés (et d'autres), avec tous leurs nodes.",
      "single": "Un seul canvas"
    },
    "loadMore": "Charger plus de canvas",
    "action": "Exporter"
  },
  "memories": {
    "title": "Souvenirs de l'agent",
    "subtitle": "Ce dont Nolë se souvient à votre sujet, sur tous vos canvas. Une ligne correspond à un souvenir — les lignes vides sont ignorées.",
    "user": {
      "title": "Souvenirs vous concernant",
      "description": "Ce dont Nolë se souvient à votre sujet, sur tous vos canvas."
    },
    "editor": {
      "overLimit": "Souvenirs à {{length}}/{{max}} caractères : la limite est dépassée de {{excess}} caractères. Supprimez ou raccourcissez des entrées avant d'enregistrer.",
      "saved": "Souvenirs enregistrés.",
      "saveFailed": "Impossible d'enregistrer les souvenirs.",
      "usage": "{{percentage}} % — {{length}}/{{max}} caractères",
      "placeholder": "Un souvenir par ligne.",
      "hint": "Une ligne = un souvenir. Les lignes vides sont ignorées. Nolë peut aussi mettre à jour ces souvenirs."
    }
  },
  "canvas": {
    "title": "Canvas",
    "subtitle": "L'icône, la couleur, l'image de couverture et le fond de ce canvas, visibles par tous ceux qui y ont accès. Seul son propriétaire peut les modifier.",
    "noCanvas": "Ouvrez les réglages depuis un canvas pour modifier son apparence.",
    "peek": "Maintenir pour prévisualiser",
    "background": {
      "color": "Couleur de fond",
      "usePreset": "Utiliser {{color}} comme fond",
      "customColor": "Couleur de fond personnalisée",
      "pattern": "Motif",
      "variants": {
        "lines": "Lignes",
        "dots": "Points",
        "cross": "Croix",
        "none": "Aucun"
      },
      "patternColor": "Couleur du motif",
      "customPatternColor": "Couleur du motif personnalisée",
      "spacing": "Espacement ({{gap}} px)",
      "lineWidth": "Épaisseur des lignes ({{size}})",
      "dotSize": "Taille des points ({{size}})",
      "preview": "Aperçu",
      "previewLabel": "Aperçu du fond",
      "sharedHint": "Visible par tous ceux qui ont accès à ce canvas."
    },
    "panel": {
      "loading": "Chargement du canvas…",
      "ownerOnly": "Seul le propriétaire de ce canvas peut modifier son apparence.",
      "saved": "Canvas mis à jour — visible par tous.",
      "saveFailed": "Impossible de mettre à jour le canvas.",
      "cover": "Image de couverture",
      "coverSet": "Définie",
      "coverHint": "Affichée sur la carte du canvas, sur la page d'accueil.",
      "background": "Fond",
      "save": "Enregistrer les modifications",
      "resetBackground": "Réinitialiser le fond"
    },
    "identity": {
      "label": "Icône et couleur",
      "chooseIcon": "Choisir une icône",
      "pasteEmoji": "Collez n'importe quel emoji",
      "customEmoji": "Emoji personnalisé",
      "use": "Utiliser",
      "removeIcon": "Retirer l'icône (utiliser l'initiale)",
      "color": "Couleur du canvas",
      "noColor": "Aucune couleur"
    },
    "cover": {
      "invalidType": "Choisissez une image PNG, JPEG, WebP, GIF ou AVIF.",
      "tooLarge": "Cette image est trop volumineuse (5 Mo maximum).",
      "previewAlt": "Aperçu de la couverture",
      "replace": "Remplacer l'image",
      "upload": "Importer une image"
    }
  },
  "sandbox": {
    "title": "L'ordinateur de Nolë",
    "subtitle": "L'ordinateur dans le cloud que Nolë utilise pour ce canvas, et les sites web qu'elle peut consulter.",
    "warning": {
      "title": "Pourquoi ne pas autoriser tout Internet ?",
      "risk": "Nolë lit ce qui se trouve sur votre canvas : documents, fichiers, pages web que vous ajoutez. Si l'un d'eux cache des instructions écrites par quelqu'un d'autre, Nolë pourrait être amenée à envoyer vos données vers le site de cette personne. Avec tout Internet ouvert, ces données pourraient partir n'importe où. Avec une courte liste, elles ne peuvent aller que vers les sites que vous avez choisis.",
      "advice": "N'autorisez donc que les sites auxquels vous faites confiance, un par un, et retirez ceux dont vous n'avez plus besoin."
    },
    "noCanvas": "Ouvrez les réglages depuis un canvas pour gérer son ordinateur.",
    "sites": {
      "unavailable": "L'ordinateur de Nolë n'est pas disponible ici.",
      "addFailed": "Impossible d'ajouter ce site",
      "removeFailed": "Impossible de retirer ce site",
      "title": "Sites que l'ordinateur de Nolë peut consulter",
      "description": "Pour protéger les données de ce canvas, l'ordinateur de Nolë est coupé d'Internet. Il peut toujours télécharger les logiciels dont il a besoin, et consulter les sites ci-dessous, quelle que soit la personne qui utilise Nolë sur ce canvas. Chacun d'eux pourrait recevoir des données de ce canvas. Les propriétaires et les éditeurs peuvent modifier la liste.",
      "empty": "Aucun site pour le moment. Nolë vous demande avant d'en consulter un.",
      "allowedBy": "Autorisé par {{name}} le {{date}}",
      "allowed": "Autorisé le {{date}}",
      "remove": "Retirer {{host}}",
      "inputLabel": "Site à autoriser",
      "allow": "Autoriser",
      "full": "Ce canvas autorise déjà le nombre maximal de sites : retirez-en un pour en ajouter un autre."
    }
  },
  "aiUsage": {
    "title": "Usage de l'IA",
    "subtitle": "Ce que coûtent vos conversations, sous-agents, titres de conversation et l'ordinateur de Nolë, jour après jour. Les montants sont ceux facturés par OpenRouter, et le temps d'utilisation de l'ordinateur au tarif de son fournisseur.",
    "empty": "Aucun usage de l'IA enregistré sur cette période.",
    "periodLabel": "Période d'usage",
    "columns": {
      "cost": "Coût",
      "calls": "Appels",
      "tokens": "Tokens",
      "day": "Jour (UTC)"
    },
    "missingCostCalls_one": "{{count}} appel sans coût indiqué",
    "missingCostCalls_other": "{{count}} appels sans coût indiqué",
    "byModel": {
      "title": "Par modèle",
      "model": "Modèle",
      "input": "Entrée",
      "output": "Sortie",
      "note": "L'entrée inclut les tokens en cache, la sortie inclut les tokens de raisonnement."
    },
    "chart": {
      "tooltipStats_one": "{{tokens}} tk · {{calls}} appel",
      "tooltipStats_other": "{{tokens}} tk · {{calls}} appels",
      "missingCost_one": "{{formatted}} sans coût indiqué",
      "missingCost_other": "{{formatted}} sans coût indiqué",
      "utcNote": "Les jours sont comptés en UTC : une activité en fin de soirée dans votre fuseau horaire peut apparaître sur la barre précédente.",
      "monthlyNote": "Sur cette période, les barres sont mensuelles ; le tableau reste journalier.",
      "stripedNote": "Une barre hachurée sous-estime la dépense réelle — OpenRouter n'a indiqué aucun coût pour une part importante de ses appels.",
      "empty": "Aucun usage enregistré sur cette période.",
      "costPerMonth": "Coût par mois",
      "costPerDay": "Coût par jour",
      "table": "Tableau",
      "chart": "Graphique"
    },
    "summary": {
      "totalCost": "Coût total",
      "range": "{{range}} (UTC)",
      "tokensHint": "Entrée et sortie confondues",
      "calls": "Appels au LLM",
      "callsHint": "Un par étape du modèle, pas par message",
      "missingCost_one": "<strong>{{missing}} appel sur {{total}} n'a indiqué aucun coût.</strong> Ses tokens sont comptés, mais sa dépense manque au total ci-dessus — le montant réel est donc plus élevé que celui affiché.",
      "missingCost_other": "<strong>{{missing}} appels sur {{total}} n'ont indiqué aucun coût.</strong> Leurs tokens sont comptés, mais leur dépense manque au total ci-dessus — le montant réel est donc plus élevé que celui affiché.",
      "truncated": "Cette période compte plus de lignes d'usage qu'une seule lecture n'en renvoie. Les chiffres ci-dessous sont partiels — réduisez la période pour obtenir un total exact."
    }
  },
  "apiTokens": {
    "title": "MCP et tokens d'API",
    "subtitle": "Créez des tokens pour permettre à des outils et agents tiers (des serveurs MCP, par exemple) d'accéder à l'API de nolënor en votre nom.",
    "hideRevoked": "Masquer les révoqués ({{count}})",
    "showRevoked": "Afficher les révoqués ({{count}})",
    "onlyRevoked": "Aucun token d'API actif — seulement des tokens révoqués.",
    "empty": "Aucun token d'API pour le moment",
    "permission": {
      "label": "Permission",
      "read": "Lecture",
      "write": "Écriture"
    },
    "list": {
      "token": "Token",
      "created": "Créé le",
      "lastUsed": "Dernière utilisation",
      "never": "Jamais",
      "revokedOn": "Révoqué le {{date}}",
      "revokeConfirmTitle": "Révoquer le token « {{name}} » ?",
      "revokeConfirmText": "Toute application qui l'utilise perdra immédiatement son accès.",
      "revoke": "Révoquer",
      "revokeTitle": "Révoquer le token",
      "revokeFailed": "Impossible de révoquer le token"
    },
    "create": {
      "trigger": "Nouveau token",
      "title": "Nouveau token d'API",
      "createdTitle": "Token créé",
      "copyNow": "Copiez ce token maintenant. Pour des raisons de sécurité, il ne sera plus affiché.",
      "copyToken": "Copier le token",
      "copyCommand": "Copier la commande",
      "copied": {
        "token": "Token copié dans le presse-papiers",
        "command": "Commande copiée dans le presse-papiers"
      },
      "copyFailed": {
        "token": "Impossible de copier le token",
        "command": "Impossible de copier la commande"
      },
      "connectClaudeCode": "Connecter Claude Code",
      "otherClients": "Exécutez-la sur une seule ligne. Les autres clients MCP ont besoin de l'URL <mono>{{url}}</mono> avec un en-tête <mono>Authorization: Bearer</mono> — ou, pour les clients comme Claude Desktop qui ne proposent que des noms d'en-tête prédéfinis, utilisez <mono>x-api-key</mono> avec le token comme valeur.",
      "namePlaceholder": "ex. Mon agent MCP",
      "creating": "Création…",
      "submit": "Créer le token",
      "failed": "Impossible de créer le token"
    },
    "edit": {
      "title": "Modifier le token",
      "updated": "Token mis à jour",
      "failed": "Impossible de mettre à jour le token"
    }
  },
  "skills": {
    "title": "Skills",
    "subtitle": "Des modules de prompt réutilisables que Nolë peut charger à la demande. Définissez le nom, la description et le contenu pour qu'elle les trouve et les utilise.",
    "new": "Nouveau skill",
    "back": "Tous les skills",
    "emptySelection": "Sélectionnez un skill à gauche, ou créez-en un nouveau.",
    "empty": "Aucun skill pour le moment.",
    "editor": {
      "notFound": "Skill introuvable.",
      "nameRequired": "Le nom du skill est obligatoire.",
      "created": "Skill créé.",
      "saved": "Skill enregistré.",
      "createFailed": "Impossible de créer le skill.",
      "saveFailed": "Impossible d'enregistrer le skill.",
      "deleted": "Skill « {{name}} » supprimé.",
      "deleteFailed": "Impossible de supprimer le skill.",
      "noDescription": "Pas encore de description",
      "draft": "Brouillon (non enregistré)",
      "deleteConfirmTitle": "Supprimer le skill « {{name}} » ?",
      "deleteConfirmText": "C'est irréversible.",
      "deleteConfirm": "Supprimer le skill",
      "namePlaceholder": "ex. mon_skill",
      "description": "Description",
      "descriptionPlaceholder": "Courte description qui permet de retrouver ce skill",
      "content": "Contenu",
      "contentHint": "Le contenu est le prompt complet chargé par Nolë. Enregistré en Markdown."
    },
    "attachments": {
      "nameRequired": "Le nom de la pièce jointe est obligatoire.",
      "added": "Pièce jointe « {{name}} » ajoutée.",
      "addFailed": "Impossible d'ajouter la pièce jointe.",
      "removed": "Pièce jointe « {{name}} » retirée.",
      "removeFailed": "Impossible de retirer la pièce jointe.",
      "title": "Pièces jointes ({{count}})",
      "add": "Ajouter une pièce jointe",
      "empty": "Aucune pièce jointe.",
      "removeConfirmTitle": "Retirer la pièce jointe « {{name}} » ?",
      "removeConfirmText": "Elle ne sera plus disponible pour ce skill.",
      "namePlaceholder": "ex. extractor.py",
      "type": "Type",
      "types": {
        "md": "Markdown (.md)",
        "txt": "Texte brut (.txt)",
        "script_py": "Script Python (.py)",
        "script_ts": "Script TypeScript (.ts)"
      },
      "contentPlaceholder": "Collez ici le contenu de la pièce jointe…",
      "adding": "Ajout…"
    }
  },
  "templates": {
    "title": "Custom nodes",
    "subtitle": "Concevez des types de nodes pour ce canvas à partir d'une bibliothèque de champs, avec une mise en page pour le canvas et une autre pour la fenêtre. Tous les éditeurs du canvas peuvent les utiliser et les modifier, et Nolë peut les lire et les écrire comme n'importe quel autre node.",
    "new": "Nouveau custom node",
    "noCanvas": "Les custom nodes appartiennent à un canvas : ouvrez ces réglages depuis un canvas pour gérer ses custom nodes.",
    "draft": {
      "firstOption": "Option 1",
      "titleField": "Titre",
      "name": "Nouveau modèle",
      "unnamedField": "Un champ n'a pas de nom.",
      "duplicateName": "Deux champs s'appellent « {{name}} »."
    },
    "list": {
      "fields_one": "{{count}} champ",
      "fields_other": "{{count}} champs",
      "databaseFields_one": "Base de données · {{count}} champ",
      "databaseFields_other": "Base de données · {{count}} champs",
      "empty": "Aucun modèle pour le moment."
    },
    "defaultValueHint": "Prérempli dans les nouveaux nodes. Laissez vide pour ne rien préremplir.",
    "modal": {
      "title": "Modifier le modèle de custom node",
      "description": "Concevez les champs d'un modèle de custom node, et la façon dont son node et sa fenêtre les affichent.",
      "discardTitle": "Abandonner les modifications non enregistrées ?",
      "discardDescription": "Ce modèle a des modifications non enregistrées. Si vous fermez maintenant, elles seront perdues.",
      "keepEditing": "Continuer l'édition",
      "discard": "Abandonner les modifications",
      "header": "Modèle",
      "noCanvas": "Ouvrez un canvas pour créer un custom node : les modèles appartiennent à un canvas.",
      "viewerCreate": "Seuls les éditeurs de ce canvas peuvent créer des custom nodes.",
      "notFound": "Ce modèle n'existe pas, ou son canvas n'est pas partagé avec vous.",
      "viewerEdit": "Seuls les éditeurs de ce canvas peuvent modifier ses modèles."
    },
    "fields": {
      "field": "Champ",
      "notInLayout": "Absent de cette mise en page",
      "new": "Nouveau champ",
      "empty": "Aucun champ pour le moment.",
      "addToLayout": "Ajouter à cette mise en page"
    },
    "preview": {
      "resize": "Redimensionner",
      "dragToResize": "Glissez pour redimensionner",
      "autoLayout": "Mise en page automatique : le titre, puis chaque champ dans l'ordre.",
      "customize": "Personnaliser",
      "hiddenFields_one": "{{count}} champ absent de la mise en page",
      "hiddenFields_other": "{{count}} champs absents de la mise en page"
    },
    "inspector": {
      "style": "Style",
      "levels": {
        "h2": "Titre 2",
        "h3": "Titre 3",
        "p": "Texte"
      },
      "width": "Largeur",
      "widths": {
        "auto": "Auto",
        "fill": "Remplir",
        "fixed": "Fixe"
      },
      "widthPx": "Largeur (px)",
      "heightPx": "Hauteur (px)",
      "titleHint": "Le titre du node, affiché comme un intitulé.",
      "showName": "Afficher le nom du champ",
      "singleLine": "Une seule ligne",
      "singleLineHint": "Couper les textes longs par des points de suspension",
      "text": "Texte",
      "textPlaceholder": "Titre de section, aide, légende…",
      "maxWidth": "Largeur max. (px)",
      "noMax": "Aucune",
      "type": "Type",
      "title": "Titre",
      "titleExplanation": "Chaque modèle a son titre : il nomme ses nodes dans la recherche, les liens et les mentions.",
      "typeSettings": "Réglages : {{type}}",
      "defaultValue": "Valeur par défaut",
      "descriptionForNole": "Description pour Nolë",
      "descriptionPlaceholder": "Ce que contient ce champ, pour aider Nolë à le lire et à le remplir",
      "usedBy": "Utilisé par {{usage}}. Supprimer le champ masque leurs valeurs sans les effacer.",
      "deleteField": "Supprimer le champ",
      "sizeOnCanvas": "Taille sur le canvas",
      "resizable": "Redimensionnable sur le canvas",
      "sizeHint": "La taille des nouveaux nodes. Faites glisser le coin de l'aperçu pour la modifier.",
      "windowLayout": "Mise en page de la fenêtre",
      "customLayout": "Mise en page personnalisée.",
      "customLayoutHidden_one": "Mise en page personnalisée. {{count}} champ n'y figure pas : la fenêtre l'affiche replié en dessous.",
      "customLayoutHidden_other": "Mise en page personnalisée. {{count}} champs n'y figurent pas : la fenêtre les affiche repliés en dessous.",
      "useAuto": "Utiliser la mise en page automatique",
      "window": "Fenêtre",
      "autoLayoutHint": "Mise en page automatique : tous les champs, les uns sous les autres, dans l'ordre de la liste des champs. Les nouveaux champs s'y ajoutent.",
      "customizeLayout": "Personnaliser la mise en page"
    },
    "editor": {
      "unknownField": "Champ inconnu",
      "emptyText": "Texte vide",
      "divider": "Séparateur",
      "rootNode": "Node",
      "addedToFieldsOnly": "{{name}} a été ajouté aux champs seulement. {{reason}}",
      "untitled": "Modèle sans titre",
      "saved": "Modèle enregistré",
      "created": "Modèle créé",
      "saveFailed": "Impossible d'enregistrer le modèle",
      "deleted": "Modèle supprimé",
      "deleteFailed": "Impossible de supprimer le modèle",
      "inAutoWindow": "Affiché dans la mise en page automatique de la fenêtre.",
      "notInNodeLayout": "Absent de la mise en page du node.",
      "notInWindowLayout": "Absent de la mise en page de la fenêtre.",
      "addToNodeLayout": "Ajouter à la mise en page du node",
      "addToWindowLayout": "Ajouter à la mise en page de la fenêtre",
      "removeFromLayout": "Retirer de la mise en page",
      "name": "Nom du modèle",
      "descriptionPlaceholder": "À quoi il sert et quand l'utiliser, pour vous et pour Nolë",
      "usedBy": "Utilisé par {{usage}}",
      "deleteConfirmTitle": "Supprimer ce modèle ?",
      "deleteConfirmText": "Il sera supprimé pour tous les éditeurs de ce canvas. C'est irréversible.",
      "deleteBlocked": "Utilisé par {{usage}} : supprimez-les d'abord, corbeille comprise",
      "delete": "Supprimer le modèle",
      "layers": "Calques",
      "autoLayers": "Automatique : le titre, puis chaque champ dans l'ordre.",
      "fields": "Champs",
      "layoutLabel": "Mise en page",
      "nodeSurface": "Node sur le canvas",
      "sampleValues": "Valeurs d'exemple",
      "samples": {
        "filled": {
          "label": "Rempli",
          "title": "Valeurs typiques"
        },
        "empty": {
          "label": "Vide",
          "title": "Un nouveau node"
        },
        "overflow": {
          "label": "Long",
          "title": "Valeurs longues : montre les mises en page qui ne tiennent pas"
        }
      },
      "zoom": "Zoom",
      "moreErrors_one": "(+{{count}} autre)",
      "moreErrors_other": "(+{{count}} autres)",
      "changedElsewhere": "Modifié ailleurs depuis que vous l'avez ouvert : enregistrer remplacera ces modifications.",
      "status": {
        "dirty": "Modifications non enregistrées. Les nodes de ce modèle se mettent à jour quand vous enregistrez.",
        "pristine": "Rien ne change tant que vous n'enregistrez pas.",
        "new": "Le modèle est créé quand vous enregistrez."
      },
      "icon": "Icône"
    }
  }
}
